// 
const XHRQueue = {};

const activeXHRSelector = '[data-active-xhr="true"]';

export const isInProgress = () => {
  return Object.values(XHRQueue)
    .filter(({ settings }) => settings.includeToProgress === true).length > 0;
};

export const removeXHR = (target) => {
  if (Array.isArray(target)) {
    target = target.join('+');
  }
  const isExists = XHRQueue[target] != null;
  delete XHRQueue[target];
  if (isExists && window.partialUpdateGlobalSettings.onChangeXHRQueue) {
    window.partialUpdateGlobalSettings.onChangeXHRQueue(XHRQueue);
  }

  if (!Array.isArray(target)) {
    target.replace(/,/g, '+');
    target = target.split('+');
  }
  target.forEach((targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      delete targetElement.dataset.activeXhr;
    }
  });
};

export const addXHR = (target, xhr, settings) => {
  if (Array.isArray(target)) {
    target = target.join('+');
  }
  target.replace(/,/g, '+');
  XHRQueue[target] = { xhr, settings };
  if (window.partialUpdateGlobalSettings.onChangeXHRQueue) {
    window.partialUpdateGlobalSettings.onChangeXHRQueue(XHRQueue);
  }
  if (!Array.isArray(target)) {
    target.replace(/,/g, '+');
    target = target.split('+');
  }
  target.forEach((targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.dataset.activeXhr = true;
    }
  });
};

export const abortXHR = (target) => {
  if (!Array.isArray(target)) {
    target.replace(/,/g, '+');
    target = target.split('+');
  }

  target.forEach((targetId) => {
    const targetXhr = XHRQueue[targetId];
    if (targetXhr) {
      targetXhr.xhr.abort();
    }
    removeXHR(targetId);
    const container = document.getElementById(targetId);
    if (container) {
      const idsForAborting = Object.keys(XHRQueue).filter((xhrId) => {
        const containsClosest = xhrId.split('+').map((id) => {
          const innerElement = document.getElementById(id);
          if (!innerElement) {
            return true;
          }
          return container.contains(innerElement);
        }).filter(isClosest => isClosest === true);
        return containsClosest.length > 0;
      });
      idsForAborting.forEach((id) => {
        const xhr = XHRQueue[id];
        if (xhr) {
          xhr.xhr.abort();
        }
        removeXHR(id);
      });
    }
  });
};

export const isInActivePUContainer = (element, excludeUiEvents) => {
  if (!element) {
    return false;
  }
  const activeClosestContainer = element.closest(activeXHRSelector);
  if (!activeClosestContainer) {
    return false;
  }
  /*if (activeClosestContainer === element) {
    return false;
  }*/
  if (!excludeUiEvents) {
    return true;
  }
  const { closestSettings } = XHRQueue[activeClosestContainer.id] || {};
  if (closestSettings && closestSettings.headers['RamJet-WithUiEvent']) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/XHRQueue.js